import { TUserGroup } from "MVVM/@types";

export const MONTAGE_ELIGIBLE_USER_GROUPS: TUserGroup[] = [
  "INTERNAL",
  "ESSENTIALS",
  "PRO",
  "CREATOR_PLAT",
];

export const CAREER_MONTAGE_ELIGIBLE_USER_GROUPS: TUserGroup[] = [
  "INTERNAL",
  "ESSENTIALS",
  "PRO",
  "CREATOR_PLAT",
];

export const canUserCreateMatchMontage = (
  userGroup: TUserGroup | string | undefined | null,
): boolean => {
  if (!userGroup) return false;
  return MONTAGE_ELIGIBLE_USER_GROUPS.includes(userGroup as TUserGroup);
};

export const canUserCreateCareerMontage = (
  userGroup: TUserGroup | string | undefined | null,
): boolean => {
  if (!userGroup) return false;
  return CAREER_MONTAGE_ELIGIBLE_USER_GROUPS.includes(userGroup as TUserGroup);
};
